import { storeCategory } from "@/stores/category.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/category_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeCategory.categories = res.data.categories;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
